import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import AddUnit from "../../core/modals/inventory/addunit";
import EditUnit from "../../core/modals/inventory/editunit";
import Swal from "sweetalert2";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { deleteUnity } from "../../slices/productSlice";
import { deleteProductUnity } from "../../api/inventoryApi";

export const Units = () => {
  const dataSource = useSelector((state) => state.products.unities);
  const dispatch = useDispatch();

  const [selectedUnity, setSelectedUnity] = useState(null); 
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Statut",
      dataIndex: "statut",
      render: () => (
        <span className="badge badge-linesuccess">
          <Link to="#">Actif</Link>
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <button
            className="btn btn-sm btn-primary me-2"
            onClick={() => handleEdit(record)}
            data-bs-target="#edit-units"
            data-bs-toggle="modal"

          >
            <i data-feather="edit" className="feather-edit"></i>
          </button>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(record.id)}
          >

            <i data-feather="trash-2" className="feather-trash-2"></i>
          </button>
        </div>
      ),
    },
  ];

  const deleteFunction = async (unityId) => {
    try {
      const response = await deleteProductUnity(unityId);
  
      if (response?.error) {
        // Gestion des erreurs retournées par le serveur
        Swal.fire("Erreur", response.error.message || "Une erreur est survenue.", "error");
      } else {
        Swal.fire("Supprimé !", "Votre unité a été supprimée avec succès.", "success");
      }
    } catch (error) {
      // Gestion des erreurs inattendues (réseau, serveur non joignable, etc.)
      Swal.fire(
        "Erreur",
        error?.response?.data?.message || "Une erreur imprévue est survenue.",
        "error"
      );
    }
  };

  // Gestion de l'ouverture de l'éditeur
  const handleEdit = (unity) => {
    setSelectedUnity(unity);

    setIsEditModalVisible(true);
  };

  // Gestion de la suppression
  const handleDelete = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui, supprimez-le !",
      cancelButtonText: "Non, annulez !",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteUnity(id)); 
        deleteFunction(id);
      }
    });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Unitées</h4>
                <h6>Gérez vos unitées de mesures</h6>
              </div>
            </div>
        
            <div className="page-btn">
              <a
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <PlusCircle className="me-2" />
                Ajouter une nouvelle unitée
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              
            
              <div className="table-responsive">
                <Table columns={columns} dataSource={dataSource} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        {isEditModalVisible && (
          <EditUnit
            unity={selectedUnity}
            onClose={() => setIsEditModalVisible(false)}
          />
        )}
        <AddUnit />
      </div>
    </>
  );
};
